import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ReportHeader = ({ 
  caseNumber, 
  generatedDate, 
  onDownloadPDF, 
  onToggleSidebar,
  isSidebarCollapsed 
}) => {
  return (
    <div className="sticky top-0 z-40 bg-card border-b border-border shadow-sm">
      <div className="px-4 md:px-6 lg:px-8 py-4">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div className="flex items-center gap-3">
            <button
              onClick={onToggleSidebar}
              className="p-2 hover:bg-muted rounded-lg transition-colors lg:hidden"
              aria-label="Toggle sidebar"
            >
              <Icon name="Menu" size={24} />
            </button>
            
            <div>
              <h1 className="text-xl md:text-2xl font-semibold text-foreground">
                Fire Forensics Report
              </h1>
              <div className="flex flex-wrap items-center gap-2 md:gap-4 mt-1 text-sm text-muted-foreground">
                <span className="flex items-center gap-1">
                  <Icon name="FileText" size={16} />
                  Case #{caseNumber}
                </span>
                <span className="flex items-center gap-1">
                  <Icon name="Calendar" size={16} />
                  {generatedDate}
                </span>
              </div>
            </div>
          </div>
          
          <div className="flex flex-wrap items-center gap-2">
            <Button
              variant="default"
              size="sm"
              iconName="Download"
              iconPosition="left"
              onClick={onDownloadPDF}
            >
              Download PDF
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportHeader;